import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { useFetch } from "@/lib/axios.config.ts";
import { ChallengeDetail } from "@/pages/challenges/types";
import { StaticPageDetail } from "@/pages/challenges/types";
import { ChallengeMemberKeys } from "./challenge-members.api";

export enum ChallengeDetailKeys {
  ChallengeDetail = "challengeDetail",
  StaticPageDetail = "staticPageDetail"
}

export const useChallengeDetail = (challengeId?: string) => {
  return queryOptions({
    queryKey: [ChallengeDetailKeys.ChallengeDetail, challengeId],
    queryFn: async () => {
      const res = await useFetch.get<ChallengeDetail>(
        `/challenges/ChallengeDetail/${challengeId}`
      );
      return res.data;
    },
    enabled: Boolean(challengeId),
  });
};

export const useStaticPageDetail = (slug?: string) => {
  return queryOptions({
    queryKey: [ChallengeDetailKeys.StaticPageDetail, slug],
    queryFn: async () => {
      const res = await useFetch.get<StaticPageDetail>(
        `/common/StaticPageDetail/${slug}`
      );
      return res.data;
    },
  });
};

export const useChallengeParticipateMutation = (challengeId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await useFetch.post(
        `/challenges/ChallengeParticipate/${challengeId}`
      );
      return res.data;
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [ChallengeDetailKeys.ChallengeDetail, challengeId],
      });
      queryClient.invalidateQueries({
        queryKey: [ChallengeMemberKeys.ChallengeMembers, challengeId],
      });
    },
  });
};
